import React, { Component } from 'react'
import IntractionActionsList from '../IntractionActionsList'
import StagesManager from '../StagesManager'
import FixedView from '../FixedView'
import { checkPermission, translate } from '../../utils/useful'
import importedIcons from '../inputs/icons'

export default class ToolsMenu extends Component {


    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }


    render() {
        return (
            <>
                <button className=' flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.settingView.showView() }}>
                    <p className='font-size-13  text-semibold' style={{ color: this.props.colors?.textColor }}>{translate('tools.Tools')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.settingView = el} nodeRef={this.setting} xOffset={this.props.language == 'fa' ? 215 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className='mb-2'>
                                    {checkPermission(this.props.permissions, `collection.${this.props.frame?._id}.viewActivityLogs`) && (

                                        <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openSearch')} language={this.props.language} data={{ title: "{{lang}}tools.Activity Log", shortcut: 'Ctrl+O', icon: importedIcons.activityLog }} />
                                    )}
                                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openSearch')} language={this.props.language} data={{ title: "{{lang}}tools.Inbox", icon: importedIcons.inbox }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openSearch')} language={this.props.language} data={{ title: "{{lang}}tools.Communications", icon: importedIcons.comunications }} />
                                    {checkPermission(this.props.permissions, `collection.${this.props.frame?._id}.conditionalFormat`) && (
                                        <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openSearch')} language={this.props.language} data={{ title: "{{lang}}tools.Conditional format", icon: importedIcons.conditionalFormat }} />
                                    )}
                                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openImport')} language={this.props.language} data={{ title: "{{lang}}tools.Import", icon: importedIcons.import }} />
                                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openExport')} language={this.props.language} data={{ title: "{{lang}}tools.Export", icon: importedIcons.export }} />
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
